var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManOnComputerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    fill: "#0E89BC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.7681 45.4755C33.9074 44.5056 34.1978 43.5823 34.6159 42.7344H20.4518V26.9559H39.4941C39.7554 26.439 40.069 25.9512 40.4291 25.504H19.7259C19.3252 25.504 19 25.8292 19 26.2299V45.8529C19 46.2536 19.3252 46.5789 19.7259 46.5789H30.5973V48.0075H28.3614V49.4593H31.9794V49.0586C31.9794 47.5951 32.6879 46.3001 33.7739 45.4755H33.7681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.9736 51.3351H20.3066V52.7869H31.9736V51.3351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.1993 30.5565C53.1993 26.9327 50.2608 24 46.6429 24C43.0249 24 40.0806 26.9385 40.0806 30.5565C40.0806 34.1745 43.0191 37.113 46.6429 37.113C50.2666 37.113 53.1993 34.1803 53.1993 30.5565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.1302 46.1608C57.8224 42.1944 54.5122 39.0701 50.4703 39.0701H42.8104C38.7627 39.0701 35.4583 42.1944 35.1505 46.1608C34.0529 46.6661 33.2864 47.7695 33.2864 49.0587V55.017H34.7382V49.0587C34.7382 48.1005 35.5164 47.3223 36.4746 47.3223H56.8061C57.7643 47.3223 58.5483 48.1005 58.5483 49.0587V55.017H60.0001V49.0587C60.0001 47.7753 59.2336 46.6661 58.1302 46.1608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.5439 32.1942V29.2383H22.885V40.2316H36.5439V35.6612H35.2372V38.9249H24.1917V30.5449H29.064V34.0816H27.4496V35.3883H30.3707V30.5449H35.2372V32.1942H36.5439Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManOnComputerIcon);
export default __webpack_public_path__ + "static/media/man-on-computer-icon.9e4b5c212e8b61e91d5ab3df36402a28.svg";
export { ForwardRef as ReactComponent };